import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "demand-day-delivery__ordered" };
const _hoisted_2 = { class: "demand-day-delivery__label" };
const _hoisted_3 = { class: "demand-day-delivery__value" };
const _hoisted_4 = { class: "demand-day-delivery__notified" };
const _hoisted_5 = { class: "demand-day-delivery__label" };
const _hoisted_6 = { class: "demand-day-delivery__value" };
import { computed } from 'vue';
import Icon from '@astina/paloma-common-ui/src/components/Icon.vue';
import trans from "@astina/paloma-common-ui/src/services/Translator";
export default /*@__PURE__*/ _defineComponent({
    __name: 'DemandDayDelivery',
    props: {
        deliveryItems: {}
    },
    setup(__props) {
        const props = __props;
        // TODO quantities should be grouped by unit
        const quantityOrdered = computed(() => {
            return props.deliveryItems
                .reduce((total, item) => total + parseFloat(item.quantityOrdered), 0);
        });
        const quantityNotified = computed(() => {
            const notifiedItems = props.deliveryItems
                .filter(item => item.quantityNotified !== null);
            if (notifiedItems.length === 0) {
                return null;
            }
            return notifiedItems
                .reduce((total, item) => total + parseFloat(item.quantityNotified || '0'), 0);
        });
        const deliveryId = computed(() => {
            if (props.deliveryItems.length === 0) {
                return null;
            }
            return props.deliveryItems[0].deliveryId;
        });
        const hasComment = computed(() => {
            return props.deliveryItems.some(item => item.comment);
        });
        const quantityReceived = computed(() => {
            const receivedItems = props.deliveryItems
                .filter(item => item.quantityReceived !== null);
            if (receivedItems.length === 0) {
                return null;
            }
            return receivedItems
                .reduce((total, item) => total + parseFloat(item.quantityReceived || '0'), 0);
        });
        const isReceived = computed(() => quantityReceived.value !== null);
        const format = (value) => {
            return value === null ? '–' : String(value);
        };
        const displayLabel = computed(() => {
            return isReceived.value
                ? trans("demand.day.received")
                : trans("demand.day.notified");
        });
        const displayValue = computed(() => {
            if (isReceived.value) {
                return `${format(quantityReceived.value)}/${format(quantityNotified.value)}`;
            }
            return format(quantityNotified.value);
        });
        return (_ctx, _cache) => {
            return (quantityOrdered.value > 0 || quantityNotified.value)
                ? (_openBlock(), _createBlock(_resolveDynamicComponent(deliveryId.value && _ctx.$isGranted('PORTAL_DELIVERIES_VIEW') ? 'RouterLink' : 'div'), _mergeProps({ key: 0 }, deliveryId.value && _ctx.$isGranted('PORTAL_DELIVERIES_VIEW') ? { to: { name: 'deliveries_delivery', params: { id: deliveryId.value } } } : {}, {
                    class: ["demand-day-delivery", {
                            'demand-day-delivery--complete': quantityReceived.value !== null ?
                                quantityOrdered.value === quantityNotified.value && quantityOrdered.value === quantityReceived.value :
                                quantityOrdered.value === quantityNotified.value,
                            'demand-day-delivery--partial': quantityReceived.value !== null ?
                                quantityReceived.value !== quantityOrdered.value || quantityReceived.value !== quantityNotified.value :
                                quantityNotified.value !== null && quantityNotified.value !== quantityOrdered.value,
                            'demand-day-delivery--unknown': quantityNotified.value === null,
                            'demand-day-delivery--with-comment': hasComment.value
                        }]
                }), {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_1, [
                            _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('demand.day.ordered')), 1),
                            _cache[0] || (_cache[0] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_3, _toDisplayString(quantityOrdered.value), 1)
                        ]),
                        _cache[2] || (_cache[2] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                                _createTextVNode(_toDisplayString(displayLabel.value) + " ", 1),
                                (hasComment.value)
                                    ? (_openBlock(), _createBlock(Icon, {
                                        key: 0,
                                        name: "comment"
                                    }))
                                    : _createCommentVNode("", true)
                            ]),
                            _cache[1] || (_cache[1] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_6, _toDisplayString(displayValue.value), 1)
                        ])
                    ]),
                    _: 1
                }, 16, ["class"]))
                : _createCommentVNode("", true);
        };
    }
});
